import Sidebar from "@/components/Sidebar/SidebarView.vue";
import Navbar from "@/components/HomeNavBar/HomeNavBar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import Swal from "sweetalert2";
import manage_incident_type_api from "./manage_incident_type_api";
import manage_incident_helper from "./manage_incident_helper";
import manage_incident_method_helpers from "./manage_incident_method_helpers";


export default {
  components: {
    Sidebar,
    Navbar,
    InactivityModal,
  },
  inject: ["client_features"],
  data() {
    return ({
      search: "",
      incident_types_datatable: null,
      loading_incident_types: true,
      saving_incident_type: false,
      deleting_incident_type_id: null,
      editing_type_id: null,
      assigning_incident_type: null,
      assigning_incident_type_id: null,
      authority_search: "",
      selected_authority_ids: [],
      original_authority_ids: [],
      admins: [],
      form_errors: {
        name: "",
        color: "",
      },
      type_form: {
        name: "",
        icon: "bi-exclamation-triangle-fill",
        color: "#0d6efd",
        file: null,
      },
      available_icons: [
        { name: "Water", value: "bi-droplet-fill" },
        { name: "Electricity", value: "bi-lightning-charge-fill" },
        { name: "Housing", value: "bi-house-door-fill" },
        { name: "Roads", value: "bi-sign-stop-fill" },
        { name: "Waste", value: "bi-trash3-fill" },
        { name: "Sewerage", value: "bi-moisture" },
        { name: "Lighting", value: "bi-lightbulb-fill" },
        { name: "Safety", value: "bi-shield-exclamation" },
        { name: "Fire", value: "bi-fire" },
        { name: "Parks", value: "bi-tree-fill" },
        { name: "Noise", value: "bi-volume-up-fill" },
        { name: "Construction", value: "bi-cone-striped" },
        { name: "Transport", value: "bi-bus-front-fill" },
        { name: "Health", value: "bi-heart-pulse-fill" },
        { name: "Animal", value: "bi-bug-fill" },
        { name: "General", value: "bi-exclamation-triangle-fill" },
      ],
      incident_types: [],
    });
  },
  computed: {
    filtered_incident_types() {
      return this.incident_types;
    },
    authorities() {
      return this.admins
        .map(this.map_authority)
        .filter(this.has_authority_id);
    },
    filtered_authorities() {
      const query = this.authority_search.trim().toLowerCase();
      if (!query) return this.authorities;
      return this.authorities.filter((authority) => (
        authority.name.toLowerCase().includes(query)
        || authority.department.toLowerCase().includes(query)
      ));
    },
    has_authority_changes() {
      const selected = this.selected_authority_ids.map(String).sort();
      const original = this.original_authority_ids.map(String).sort();
      return selected.length !== original.length
        || selected.some((id, index) => id !== Reflect.get(original, index));
    },
  },
  watch: {
    "type_form.color": "apply_incident_type_colors",
    incident_types: {
      handler: "apply_incident_type_colors",
      deep: true,
    },
  },
  mounted() {
    this.get_incident_types_by_scope();
    this.get_organization_admins();
    this.apply_incident_type_colors();
  },
  updated() {
    this.apply_incident_type_colors();
  },
  beforeUnmount() {
    this.destroy_incident_types_datatable();
    $("#incidentTypeModal").off(".manageIncidentType");
  },
  methods: {
    ...manage_incident_type_api,
    ...manage_incident_helper,
    ...manage_incident_method_helpers,
    toggle_sidebar() {
      this.$refs.sidebar?.$el.classList.toggle("close");
    },
    toggleSidebar() {
      this.toggle_sidebar();
    },
    open_type_form(type = null) {
      this.form_errors = { name: "", color: "" };
      this.editing_type_id = type?.id || null;
      this.type_form = type
        ? {
          name: type.name,
          icon: type.icon,
          color: type.color,
          file: type.file?.file_url || null,
        }
        : {
          name: "",
          icon: "bi-exclamation-triangle-fill",
          color: "#0d6efd",
          file: null,
        };
      if (this.type_form.file) {
        this.add_uploaded_icon_option(this.type_form.file, "Uploaded icon");
      }
      this.$nextTick(() => {
        $("#incidentTypeModal")
          .one("shown.bs.modal", () => this.$refs.typeNameInput?.focus())
          .modal("show");
      });
    },
    close_type_form() {
      $("#incidentTypeModal").modal("hide");
    },
    reset_type_form() {
      this.editing_type_id = null;
      this.form_errors = { name: "", color: "" };
    },
    open_assign_modal(type) {
      this.assigning_incident_type = type;
      this.authority_search = "";
      this.selected_authority_ids = Array.isArray(type.authority_ids)
        ? type.authority_ids
          .map((id) => this.authorities.find((authority) => String(authority.id) === String(id))?.id)
          .filter(Boolean)
        : [];
      this.original_authority_ids = [...this.selected_authority_ids];
      this.$nextTick(() => $("#assignAuthorityModal").modal("show"));
    },
    close_assign_modal() {
      $("#assignAuthorityModal").modal("hide");
    },
    toggle_authority(authority_id) {
      if (this.selected_authority_ids.includes(authority_id)) {
        this.selected_authority_ids = this.selected_authority_ids.filter((id) => id !== authority_id);
        return;
      }
      this.selected_authority_ids.push(authority_id);
    },
    assign_authority() {
      if (!this.assigning_incident_type || !this.has_authority_changes) return;
      this.assign_incident_type_to_admin(this.assigning_incident_type.id);
    },
    get_assigned_authorities(type) {
      const assigned_ids = Array.isArray(type.authority_ids) ? type.authority_ids : [];
      return this.authorities.filter((authority) => (
        assigned_ids.some((id) => String(id) === String(authority.id))
      ));
    },
    handle_type_color_input() {
      this.form_errors.color = "";
      this.apply_incident_type_colors();
    },
    get_safe_incident_color(color) {
      return /^#[0-9a-f]{6}$/i.test(String(color || "")) ? color : "#0d6efd";
    },
    apply_background_color(element) {
      const color = this.get_safe_incident_color(element.dataset.incidentColor);
      element.style.backgroundColor = color;
    },
    apply_icon_color(element) {
      const color = this.get_safe_incident_color(element.dataset.incidentColor);
      element.style.color = color;
      element.style.backgroundColor = `${color}20`;
    },
    apply_incident_type_colors() {
      this.$nextTick(() => {
        const root_element = this.$el;
        if (!root_element) return;
        root_element
          .querySelectorAll("[data-incident-bg-color]")
          .forEach((element) => {
            this.apply_background_color(element);
          });
        root_element
          .querySelectorAll("[data-incident-icon-color]")
          .forEach((element) => {
            this.apply_icon_color(element);
          });
      });
    },
    init_incident_types_datatable() {
      const table = this.get_incident_types_table();
      if (!table) return;

      this.destroy_incident_types_datatable();
      this.incident_types_datatable = table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 5,
        lengthMenu: [5, 10, 25, 50],
        autoWidth: false,
        order: [[0, "asc"]],
        columnDefs: [
          { orderable: false, searchable: false, targets: [4] },
        ],
        layout: {
          topStart: "pageLength",
          topEnd: null,
          bottomStart: "info",
          bottomEnd: "paging",
        },
        language: {
          lengthMenu: "Show _MENU_ types",
          info: "Showing _START_ to _END_ of _TOTAL_ types",
          infoEmpty: "No incident types found",
          zeroRecords: "No incident types match your search",
          paginate: {
            previous: "Previous",
            next: "Next",
          },
        },
      });
      if (this.search) this.incident_types_datatable.search(this.search).draw();
    },
    destroy_incident_types_datatable() {
      if (typeof $ === "undefined" || !$.fn?.DataTable) return;
      if ($.fn.DataTable.isDataTable("#incident-types-table")) {
        $("#incident-types-table").DataTable().destroy();
      }
      this.incident_types_datatable = null;
    },
    refresh_incident_types_datatable() {
      this.$nextTick(this.init_incident_types_datatable);
    },
    search_incident_types() {
      this.incident_types_datatable?.search(this.search).draw();
    },
    validate_type_form(name) {
      this.form_errors = { name: "", color: "" };
      if (!name) {
        this.form_errors.name = "Incident type name is required";
      }
      if (!/^#[0-9a-f]{6}$/i.test(this.type_form.color)) {
        this.form_errors.color = "Choose a valid six-digit color";
      }
      return !this.form_errors.name && !this.form_errors.color;
    },
    has_duplicate_type(name) {
      return this.incident_types.some((type) => (
        type.id !== this.editing_type_id && type.name.toLowerCase() === name.toLowerCase()
      ));
    },
    persist_type() {
      if (this.editing_type_id) {
        this.edit_incident_type();
      } else {
        this.create_incident_type();
      }
    },
    save_type() {
      const name = this.type_form.name.trim();
      if (!this.validate_type_form(name)) return;
      if (this.has_duplicate_type(name)) {
        this.form_errors.name = "An incident type with this name already exists";
        return;
      }
      this.persist_type();
    },
    delete_type(type) {
      Swal.fire({
        title: "Are you sure?",
        text: `This will permanently delete the "${type.name}" incident type.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        position: "bottom-end",
        toast: true,
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.delete_incident_type(type);
      });
    },
  },
};
